import { Link } from 'gatsby';
import React from 'react';

const formatUrl = (url) => {
  if (url.includes('http')) {
    return url;
  }

  if (url.startsWith('/')) {
    return url;
  }
  return `/${url}`;
};

const NavLink = ({ link }) => {
  const url = link.externalLink || link.slug;

  if (link.externalLink) {
    return (
      <a
        href={formatUrl(url)}
        className="navigation-link w-nav-link"
        style={{ fontSize: 12 }}
        target="_blank"
        rel="noreferrer"
      >
        {link.icon && link.icon.url && (
          <img src={link.icon.url} style={{ height: 12, marginRight: 5 }} alt="Link" />
        )}
        {link.label}
      </a>
    );
  }

  return (
    <Link to={formatUrl(url)} className="navigation-link w-nav-link" style={{ fontSize: 12 }}>
      {link.icon && link.icon.url && (
        <img src={link.icon.url} style={{ height: 12, marginRight: 5 }} alt="Link" />
      )}
      {link.label}
    </Link>
  );
};

const Secondary = ({ links }) => {
  const iconLinks = links.filter((link) => link.icon);
  const textLinks = links.filter((link) => !link.icon);

  return (
    <nav role="secondary navigation" className="nav-menu-2 w-nav-menu">
      <div className="secondary-nav">
        {iconLinks.map((link) => (
          <NavLink link={link} />
        ))}
      </div>
      <div className="secondary-nav">
        {textLinks.map((link) => (
          <NavLink link={link} />
        ))}
      </div>
    </nav>
  );
};

export { Secondary };
